import React from 'react';
import { PluginEnum } from '@meitu/saas-editor-core/es/version-types';
import { ArtTextButton } from '@meitu/saas-editor-ui/es/components/art-text-button';
import useOpenPlugins from '@/editor/collapse/views/more-collapse/hooks/use-open-plugins';
import { useDragLayer } from '@/hooks/use-drag-layer';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { isIntl } from '@/react-process-env';
import { useStoreActions, useStoreState } from '@/store';
import './style.less';

export const ShortcutButtons: React.FC = () => {
    const { $t } = useLocaleStore();

    const { openPlugin } = useOpenPlugins();

    const customParams = useStoreState((state) => state.sdkModel.customParams);
    const getRecordInfo = useStoreActions((actions) => actions.recordModel.getRecordInfo);
    const dragLayerHelper = useDragLayer();

    const showArtTextButton = !isIntl && !customParams.hideTextMenuContent;

    const addTrack = () => {
        const recordId = getRecordInfo().id;

        window._stat_track('tpbj_subfunction_click', {
            func: '12_50',
            click_type: 1,
            open: 1,
            record_id: recordId,
        });

        window._stat_track('tpbj_subfunction_tick', {
            func: '12_50',
            record_id: recordId,
        });
    };

    const addByDefaultTitle = (byMousePosition?: boolean) => {
        editor.textLayer.addByDefaultTitle(byMousePosition);
        addTrack();
    };

    const addByDefaultSubTitle = (byMousePosition?: boolean) => {
        editor.textLayer.addByDefaultSubTitle(byMousePosition);
        addTrack();
    };

    const addByDefaultContent = (byMousePosition?: boolean) => {
        editor.textLayer.addByDefaultContent(byMousePosition);
        addTrack();
    };

    const openArtTextPlugin = () => {
        openPlugin({ func: PluginEnum.AI_TEXT });
        window._stat_track('tpbj_subfunction_click', {
            func: '12_122',
            click_type: 1,
            open: 1,
            record_id: getRecordInfo().id,
        });
    };

    return (
        <div className="shortcut-buttons">
            <p className="shortcut-buttons__desc">{$t((v) => v.collapse.textCollapse.clickToAddText)}</p>
            <ul className="shortcut-buttons__buttons">
                <li
                    className="shortcut-buttons__button shortcut-buttons__button--title"
                    onClick={() => addByDefaultTitle(false)}
                    draggable="true"
                    onMouseDown={(ev) => {
                        console.log('onMouseDown');
                        dragLayerHelper.init(
                            {
                                callback: () => addByDefaultTitle(true),
                            },
                            ev,
                        );
                    }}
                    onMouseUp={() => {
                        dragLayerHelper.destroy();
                    }}
                >
                    {$t((v) => v.collapse.textCollapse.title)}
                </li>
                <li
                    className="shortcut-buttons__button shortcut-buttons__button--sub-title"
                    onClick={() => addByDefaultSubTitle(false)}
                    draggable="true"
                    onMouseDown={(ev) => {
                        console.log('onMouseDown');
                        dragLayerHelper.init(
                            {
                                callback: () => addByDefaultSubTitle(true),
                            },
                            ev,
                        );
                    }}
                    onMouseUp={() => {
                        dragLayerHelper.destroy();
                    }}
                >
                    {$t((v) => v.collapse.textCollapse.subTitle)}
                </li>
                <li
                    className="shortcut-buttons__button shortcut-buttons__button--content"
                    onClick={() => addByDefaultContent(false)}
                    draggable="true"
                    onMouseDown={(ev) => {
                        console.log('onMouseDown');
                        dragLayerHelper.init(
                            {
                                callback: () => addByDefaultContent(true),
                            },
                            ev,
                        );
                    }}
                    onMouseUp={() => {
                        dragLayerHelper.destroy();
                    }}
                >
                    {$t((v) => v.collapse.textCollapse.contentText)}
                </li>
            </ul>
        </div>
    );
};
